import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Fields } from '@k2/common/k2-forms-state/types';
import { Observable } from 'rxjs';

@Component({
    selector: 'cost-savings-fields',
    templateUrl: 'cost-savings-fields.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CostSavingsFieldsComponent {
  readonly fields: Observable<Fields>;
}
